import {TWO_FACTOR_PASSWORD_ERRORS} from '../constants/twoFactorMessages';
import {
  readPersistedJson,
  removePersistedKey,
  writePersistedJson,
} from './twoFactorPersistedStorage';

const STORAGE_PREFIX = 'mhd:2fa-pwd-lockout:';

const storageKey = userId => `${STORAGE_PREFIX}${userId}`;

const readStoredLockout = userId => {
  if (!userId) {
    return null;
  }

  const parsed = readPersistedJson(storageKey(userId));
  if (!parsed || !parsed.expiresAt) {
    return null;
  }

  const retryAfterSeconds = Math.ceil((parsed.expiresAt - Date.now()) / 1000);

  if (retryAfterSeconds <= 0) {
    removePersistedKey(storageKey(userId));
    return null;
  }

  return {
    message: parsed.message || TWO_FACTOR_PASSWORD_ERRORS.LOCKOUT,
    retryAfterSeconds,
  };
};

export const saveTwoFactorPasswordLockout = (
  userId,
  retryAfterSeconds,
  message,
) => {
  if (!userId || !retryAfterSeconds) {
    return;
  }

  writePersistedJson(storageKey(userId), {
    expiresAt: Date.now() + retryAfterSeconds * 1000,
    message: message || TWO_FACTOR_PASSWORD_ERRORS.LOCKOUT,
  });
};

export const getTwoFactorPasswordLockout = userId => readStoredLockout(userId);

export const clearTwoFactorPasswordLockout = userId => {
  if (!userId) {
    return;
  }

  removePersistedKey(storageKey(userId));
};

export const isTwoFactorPasswordLockedOut = userId =>
  readStoredLockout(userId) != null;



// WEBPACK FOOTER //
// ./src/helpers/twoFactorPasswordLockout.js